<template>
  <div ref="root" class="ui-action" :style="{ 'min-height': minHeight + 'px' }">
    <div ref="grid" class="ui-action__grid">
      <div class="ui-action__col" v-for="slot in $eachslot('default')" v-bind:key="slot.key">
        <slot v-bind:name="slot.name"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import eachslot from '@/mixins/eachslot'

export default {
  mixins: [eachslot],
  data() {
    return {
      minHeight: 0
    }
  },
  methods: {
    update() {
      // -8 because of negative margin-top
      this.minHeight = this.$refs.grid.offsetHeight - 8
    }
  },
  updated() {
    this.update()
  },
  mounted() {
    this.update()
    this.$refs.root.addEventListener('transitionend', this.update)
  },
  beforeDestroy() {
    this.$refs.root.removeEventListener('transitionend', this.update)
  }
}
</script>

<style lang="stylus">
.ui-action {
  margin-top: $spacer-3;

  .v-btn--outline {
    background: white !important;
  }

  &__grid {
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    margin-left: ($spacer-2 / -2);
    margin-right: ($spacer-2 / -2);
    margin-top: ($spacer-2 * -1);
    right: $spacer-3;
    position: fixed;
    bottom: $spacer-3;
    z-index: 1;
  }

  &__col {
    display: block;
    flex: 0 1 auto;
    margin-left: ($spacer-2 / 2);
    margin-right: ($spacer-2 / 2);
    margin-top: $spacer-2;

    > * {
      margin: 0 !important;
    }
  }

  &--not-connected {
    .ui-action__grid {
      bottom: ($spacer-3 + 32px); //32px is the default height for v-footer https://v1.vuetifyjs.com/en/components/footer
    }
  }
}

@media $display-breakpoints.md-and-up {
  .ui-action {
    margin-top: $spacer-4;

    &__grid {
      right: $spacer-4;
      bottom: $spacer-4;
    }
    &--not-connected {
    .ui-action__grid {
      bottom: ($spacer-4 + 32px); //32px is the default height for v-footer https://v1.vuetifyjs.com/en/components/footer
    }
  }
  }
}
</style>

<docs>
**Toujours utiliser à la fin d'une _view_.**

Positionner des boutons d'actions dans le coin
inférieur droit de l'écran. 
Ceux-ci sont toujours visible.

``` html
<template>
  <v-container>
    <!-- Contenu -->
    <ui-action>
      <v-btn>Bouton #1</v-btn>
      <v-btn>Bouton #2</v-btn>
    </ui-action>
  </v-container>
</template>
```

</docs>
